import React from 'react';
import { Link } from 'react-router-dom';

export default function LandingCTA() {
  return (
    <section style={{ background: '#ffffff', padding: '100px 24px', fontFamily: "'Plus Jakarta Sans', sans-serif", textAlign: 'center' }}>
      <div style={{ maxWidth: 560, margin: '0 auto' }}>
        <h2 style={{ fontSize: 'clamp(1.6rem, 3vw, 2rem)', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em', marginBottom: 16 }}>
          Empieza hoy. La demo está lista.
        </h2>
        <p style={{ fontSize: '1rem', color: '#64748b', lineHeight: 1.65, marginBottom: 36 }}>
          Accede con la cuenta demo y explora todas las funcionalidades con datos reales precargados.
        </p>
        <div className="cta-button-wrap">
          <Link
            to="/login"
            className="cta-primary-btn"
            style={{
              display: 'inline-block',
              background: '#EA580C',
              color: '#ffffff',
              fontSize: 16,
              fontWeight: 700,
              textDecoration: 'none',
              padding: '15px 36px',
              borderRadius: 999,
              boxShadow: '0 4px 20px rgba(234,88,12,0.28)',
              transition: 'background 0.15s, transform 0.1s',
              marginBottom: 20,
            }}
            onMouseEnter={e => { e.currentTarget.style.background = '#c2410c'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#EA580C'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            Abrir la demo →
          </Link>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginTop: 4 }}>
          <span style={{ fontSize: 13, color: '#cbd5e1' }}>o</span>
          <Link
            to="/register"
            style={{ fontSize: 14, color: '#64748b', fontWeight: 500, textDecoration: 'none', borderBottom: '1px solid #e2e8f0', paddingBottom: 1, transition: 'color 0.15s, border-color 0.15s' }}
            onMouseEnter={e => { e.currentTarget.style.color = '#EA580C'; e.currentTarget.style.borderBottomColor = '#EA580C'; }}
            onMouseLeave={e => { e.currentTarget.style.color = '#64748b'; e.currentTarget.style.borderBottomColor = '#e2e8f0'; }}
          >
            Crear cuenta gratis
          </Link>
        </div>
      </div>
      <style>{`
        @media (max-width: 480px) {
          .cta-button-wrap {
            display: flex;
            justify-content: center;
          }
          .cta-primary-btn {
            display: block !important;
            width: 100% !important;
            max-width: 320px !important;
            text-align: center !important;
            padding: 16px 20px !important;
            font-size: 17px !important;
            margin-bottom: 20px !important;
          }
        }
      `}</style>
    </section>
  );
}
